import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Lightbulb, ChevronRight, X } from 'lucide-react'

interface NextStepHint {
  routePattern: RegExp
  condition?: (project: any) => boolean
  message: string
  actionLabel: string
  actionPath: (projectId: string) => string
}

const NEXT_STEP_HINTS: NextStepHint[] = [
  {
    routePattern: /^\/projects\/[^/]+\/levantamento\/?$/,
    message: 'Após concluir o levantamento, revise a cobertura das atividades.',
    actionLabel: 'Revisar cobertura',
    actionPath: (id) => `/projects/${id}/review-activities`,
  },
  {
    routePattern: /^\/projects\/[^/]+\/review-activities\/?$/,
    message: 'Consulte o relatório completo de materiais do projeto.',
    actionLabel: 'Ver Relatório',
    actionPath: (id) => `/projects/${id}/levantamento-report`,
  },
]

interface NextStepBannerProps {
  projectId?: string
  project?: any
}

export function NextStepBanner({ projectId, project }: NextStepBannerProps) {
  const { pathname } = useLocation()
  const navigate = useNavigate()

  const hint = NEXT_STEP_HINTS.find(h =>
    h.routePattern.test(pathname) &&
    (!h.condition || h.condition(project))
  )

  const [dismissed, setDismissed] = useState(false)

  if (!hint || dismissed || !projectId) return null

  return (
    <div className="flex items-center gap-3 px-4 py-2.5 rounded-lg bg-amber-50 border border-amber-100 mb-4">
      <Lightbulb className="h-4 w-4 text-amber-500 flex-shrink-0" />
      <p className="flex-1 text-sm text-amber-800">{hint.message}</p>
      <Button
        size="sm"
        variant="outline"
        className="border-amber-200 text-amber-700 hover:bg-amber-100 flex-shrink-0 h-7 text-xs"
        onClick={() => navigate(hint.actionPath(projectId))}
      >
        {hint.actionLabel}
        <ChevronRight className="ml-1 h-3.5 w-3.5" />
      </Button>
      <button
        onClick={() => setDismissed(true)}
        className="text-amber-400 hover:text-amber-600 flex-shrink-0"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  )
}
